import { render, staticRenderFns } from "./MessagePreviewTemplates.vue?vue&type=template&id=61a45a7f&"
import script from "./MessagePreviewTemplates.vue?vue&type=script&lang=ts&"
export * from "./MessagePreviewTemplates.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
installComponents(component, {VCol,VCombobox})
